import React from 'react';

export const cardImageUrl = (id) => `/cards/${id}.webp`;

/**
 * Renders the pre-generated WebP illustration for a node (public/cards/{id}.webp).
 */
const CardArt = ({ id, title }) => (
  <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <img
      src={cardImageUrl(id)}
      alt={title || ''}
      loading="lazy"
      decoding="async"
      style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'drop-shadow(0 3px 10px rgba(0,0,0,0.25))' }}
    />
  </div>
);

export default CardArt;
